<template>
    <md-icon class="md-icon-image" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g>
                <path fill="#343A40" d="M415.33,160.33,351.67,96.67A36.44,36.44,0,0,0,325.91,86H122.43A36.43,36.43,0,0,0,86,122.43V389.57A36.43,36.43,0,0,0,122.43,426H389.57A36.43,36.43,0,0,0,426,389.57V186.09a36.44,36.44,0,0,0-10.67-25.76ZM256,377.43a48.57,48.57,0,1,1,48.57-48.57A48.57,48.57,0,0,1,256,377.43Zm72.86-231.11v76.29a9.1,9.1,0,0,1-9.11,9.1H143.68a9.1,9.1,0,0,1-9.11-9.1V143.68a9.11,9.11,0,0,1,9.11-9.11H317.11a9.11,9.11,0,0,1,6.44,2.67l2.64,2.64A9.1,9.1,0,0,1,328.86,146.32Z"/>
            </g>
        </svg>
    </md-icon>
</template>

<script>
    import MdIcon from "../../../components/MdIcon/MdIcon";

    export default {
        name: 'GdDoSaveIcon',
        components: {
            MdIcon
        }
    }
</script>
